import { useMemo } from 'react'
import qrcode from 'qrcode-generator'

// Rein clientseitiger QR-Code (Variante A). Erzeugt das Modul-Raster im Browser-Speicher und rendert es als
// SVG-DOM (ein einziger <path>) — KEIN Datenbank-Zugriff, NICHTS wird persistiert (rein vorübergehend, lebt nur
// solange die Komponente sichtbar ist). Wir kodieren bloß die otpauth://-URL, die der Server ohnehin schon an den
// Browser geliefert hat — also keine neue Daten-Exposition. Bewusst LOKAL erzeugt: das TOTP-Secret darf niemals an
// einen fremden QR-Webdienst gehen. CSP-konform: SVG-Präsentationsattribute (fill) statt inline-Styles, gebündelter
// Code statt inline-Script.
export function QrCode({ value, label }: { value: string; label: string }) {
  // Quiet-Zone von 4 Modulen (QR-Spezifikation) rundherum, sonst scannen viele Apps schlechter.
  const { path, size } = useMemo(() => {
    const qr = qrcode(0, 'M') // 0 = kleinste passende Version automatisch, ECC-Level M
    qr.addData(value) // Byte-Modus (Default) — passend für URLs
    qr.make()
    const count = qr.getModuleCount()
    const margin = 4
    let d = ''
    for (let row = 0; row < count; row++) {
      for (let col = 0; col < count; col++) {
        if (qr.isDark(row, col)) d += `M${col + margin} ${row + margin}h1v1h-1z`
      }
    }
    return { path: d, size: count + margin * 2 }
  }, [value])

  return (
    <svg className="wf-qr" viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label} shapeRendering="crispEdges">
      <rect width={size} height={size} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  )
}
